/** Payment deadlines are calendar dates, never local-midnight instants. */
export const PAYMENT_TERM_CODES = ["cash_on_delivery", "net_7", "net_15", "net_30", "net_60", "end_of_month"] as const;
export type PaymentTermCode = typeof PAYMENT_TERM_CODES[number];
export function isPaymentTermCode(value: unknown): value is PaymentTermCode {
  return typeof value === "string" && (PAYMENT_TERM_CODES as readonly string[]).includes(value);
}
export function calculatePaymentDueDate(day: string, term: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || !isPaymentTermCode(term)) return null;
  const date = new Date(`${day}T00:00:00.000Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== day) return null;
  if (term === "end_of_month") date.setUTCMonth(date.getUTCMonth() + 1, 0);
  else if (term !== "cash_on_delivery") date.setUTCDate(date.getUTCDate() + Number(term.slice(4)));
  return date.toISOString().slice(0, 10);
}
/** Legacy receipt_date is a timestamp without timezone carrying a date label. */
export function receiptCalendarDate(value: Date | string): string {
  return value instanceof Date ? value.toISOString().slice(0, 10) : value.slice(0, 10);
}
